import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fb87bd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href", "target"]
const _hoisted_3 = {
  key: 1,
  class: "blt1"
}
const _hoisted_4 = {
  key: 1,
  class: "blt1"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["href", "target"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "hasChildren"
}, [
  /*#__PURE__*/_createTextVNode(" その他 "),
  /*#__PURE__*/_createElementVNode("span", { class: "blt1" })
], -1))
const _hoisted_9 = ["href", "target"]
const _hoisted_10 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.isDataFetched)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedItems, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.categoryId + item.categoryName + item.displayOrder
            }, [
              (item.categoryId === '999')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: item.linkUrl,
                    target: item.isSaparateTab ? '_blank' : '_self',
                    class: _normalizeClass({ hasChildren: item.children && item.children.length > 0 })
                  }, [
                    _createTextVNode(_toDisplayString(item.categoryName) + " ", 1),
                    (_ctx.getNotificationCount(item) > 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass([
                'notification-badge',
                { 'small-font': _ctx.getNotificationCount(item) > 99 },
              ])
                        }, _toDisplayString(_ctx.getNotificationCount(item) > 99
                  ? "99+"
                  : _ctx.getNotificationCount(item)), 3))
                      : _createCommentVNode("", true),
                    (item.children && item.children.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_2))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: item.linkUrl,
                    target: item.isSaparateTab ? '_blank' : '_self',
                    class: _normalizeClass({ hasChildren: item.children && item.children.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.categoryName) + " ", 1),
                      (_ctx.getNotificationCount(item) > 0)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass([
                'notification-badge',
                { 'small-font': _ctx.getNotificationCount(item) > 99 },
              ])
                          }, _toDisplayString(_ctx.getNotificationCount(item) > 99
                  ? "99+"
                  : _ctx.getNotificationCount(item)), 3))
                        : _createCommentVNode("", true),
                      (item.children && item.children.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "target", "class"])),
              (item.children && item.children.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: child.categoryId + child.categoryName + child.displayOrder
                        }, [
                          (child.categoryId === '999')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: child.linkUrl,
                                target: child.isSaparateTab ? '_blank' : '_self'
                              }, [
                                _createTextVNode(_toDisplayString(child.categoryName) + " ", 1),
                                (_ctx.getCategoryNoftCnt(child.categoryId) > 0)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass([
                      'notification-badge',
                      {
                        'small-font': _ctx.getCategoryNoftCnt(child.categoryId) > 99,
                      },
                    ])
                                    }, _toDisplayString(_ctx.getCategoryNoftCnt(child.categoryId) > 99
                        ? "99+"
                        : _ctx.getCategoryNoftCnt(child.categoryId)), 3))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_6))
                            : (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: child.linkUrl,
                                target: child.isSaparateTab ? '_blank' : '_self'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(child.categoryName) + " ", 1),
                                  (_ctx.getCategoryNoftCnt(child.categoryId) > 0)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass([
                      'notification-badge',
                      {
                        'small-font': _ctx.getCategoryNoftCnt(child.categoryId) > 99,
                      },
                    ])
                                      }, _toDisplayString(_ctx.getCategoryNoftCnt(child.categoryId) > 99
                        ? "99+"
                        : _ctx.getCategoryNoftCnt(child.categoryId)), 3))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["to", "target"]))
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.otherItems.length > 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", null, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherItems, (other) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: other.categoryId + other.categoryName + other.displayOrder
                      }, [
                        (other.categoryId === '999')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: other.linkUrl,
                              target: other.isSaparateTab ? '_blank' : '_self'
                            }, [
                              _createTextVNode(_toDisplayString(other.categoryName) + " ", 1),
                              (_ctx.getNotificationCount(other) > 0)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass([
                      'notification-badge',
                      { 'small-font': _ctx.getNotificationCount(other) > 99 },
                    ])
                                  }, _toDisplayString(_ctx.getNotificationCount(other) > 99
                        ? "99+"
                        : _ctx.getNotificationCount(other)), 3))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_9))
                          : (_openBlock(), _createBlock(_component_router_link, {
                              key: 1,
                              to: other.linkUrl,
                              target: other.isSaparateTab ? '_blank' : '_self'
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(other.categoryName) + " ", 1),
                                (_ctx.getNotificationCount(other) > 0)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass([
                      'notification-badge',
                      { 'small-font': _ctx.getNotificationCount(other) > 99 },
                    ])
                                    }, _toDisplayString(_ctx.getNotificationCount(other) > 99
                        ? "99+"
                        : _ctx.getNotificationCount(other)), 3))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["to", "target"]))
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}